import React from 'react';
import './Media.css';

import img1a from './assets/img1a.jpg';
import img1b from './assets/img1b.jpg';
import img1c from './assets/img1c.jpg';

import img2a from './assets/img2a.jpg';
import img2b from './assets/img2b.jpg';
import img2c from './assets/img2c.jpg';



import img4a from './assets/img4a.jpg';
import img4b from './assets/img4b.jpg';
import img4c from './assets/img4c.jpg';

import img5 from './assets/img5.jpg';

import img6a from './assets/img6a.jpg';
import img6b from './assets/img6b.jpg';
import img6c from './assets/img6c.jpg';


import img7a from './assets/img7a.jpg';
import img7b from './assets/img7b.jpg';
import img7c from './assets/img7c.jpg';


const MediaPage = () => {
  return (
    <div className="media-page">

      {/* Section 1 */}
      <section className="media-section">
        <h2>12th April – Mwangaza Dream Come True</h2>
        <p>
          On 12th April 2025, it was a moment of the founder's dream come true when her family members experienced
          empowerment and laboratory services of the newly established Mwangaza Wellness and Medical Centre
          in Kiamwangi, Karatina. A tribute to her late Dad, Douglas Irimu Kanja. This is a center for prevention and
          control of Diabetes and High BP. Mwangaza opened its doors to the public on Monday 14 April 2025.
        </p>
        <p className="achievement"><strong>Achievement:</strong> Successfully launched the center and delivered first community services in memory of the founder’s father.</p>
        <div className="media-gallery row-layout">
          <img src={img1a} alt="Family Empowerment 1" />
          <img src={img1b} alt="Family Empowerment 2" />
          <img src={img1c} alt="Family Empowerment 3" />
        </div>
      </section>

      <div className="red-divider"></div>


      {/* Section 2 */}
      <section className="media-section">
        <h2>8th May – CHPs Training at Mwangaza</h2>
        <p>
          CHPs from Mathira East had a one-day training on 8th May 2025 at Mwangaza.
        </p>
        <p className="achievement"><strong>Achievement:</strong> Equipped community health promoters with vital knowledge on diabetes and hypertension.</p>
        <div className="media-gallery row-layout">
          <img src={img2a} alt="CHP Training 1" />
          <img src={img2b} alt="CHP Training 2" />
          <img src={img2c} alt="CHP Training 3" />
        </div>
      </section>

<div className="red-divider"></div>

      {/* Section 3 */}
      <section className="media-section single-layout">
        <div className="single-content">
          <h2>11th May – Awareness at Karatina Catholic Church</h2>
          <p>
            On 11th May 2025, the Mwangaza team engaged the congregation at Karatina Catholic Church in a health awareness session on the prevention and control of hypertension and diabetes. The talk focused on the link between unhealthy diet, body weight, inactivity, and the role of high blood cholesterol—emphasizing healthy lifestyle habits for prevention.
          </p>
          <p className="achievement"><strong>Achievement:</strong>  Successfully reached a faith-based audience with vital health education on managing cholesterol and preventing chronic lifestyle diseases.</p>
        </div>
      </section>

      <div className="red-divider"></div>


      {/* Section 4 */}
      <section className="media-section">
        <h2>26th May – Magutu Women Guild</h2>
        <p>
          On 26th May 2025, Mwangaza Wellness and Medical Centre conducted a half-day session with over 300 women from the Magutu Women Guild at PCEA Gitunduti Church. The session focused on understanding hypertension and diabetes, and emphasized lifestyle interventions such as healthy eating, weight management, and physical activity.
        </p>
        <p className="achievement"><strong>Achievement:</strong> Empowered a large group of women with practical knowledge to prevent and manage chronic conditions through sustainable lifestyle changes.</p>
        <div className="media-gallery row-layout">
          <img src={img4a} alt="Magutu Women 1" />
          <img src={img4b} alt="Magutu Women 2" />
          <img src={img4c} alt="Magutu Women 3" />
        </div>
      </section>

<div className="red-divider"></div>

      {/* Section 5 */}
      <section className="media-section single-layout">
        <div className="single-content">
          <h2>27th May – KTDA Leaders Wellness Intro</h2>
          <p>
            On 27th May 2025, Mwangaza Wellness and Medical Centre was introduced to over 300 KTDA leaf-buying center leaders at Ragati Factory. The team presented the wellness clinic model as a proactive approach to preventing hypertension and diabetes—emphasizing that prevention begins with regular health checks for people who feel well, not just treatment when illness strikes.
          </p>
          <p className="achievement"><strong>Achievement:</strong> Raised awareness among key industry leaders on the importance of preventive health, laying the foundation for future collaboration in community wellness initiatives.</p>
        </div>
                <div className="single-image">
          <img src={img5} alt="KTDA Leaders Meeting" />
        </div>
      </section>

<div className="red-divider"></div>

      {/* Section 6 */}
      <section className="media-section">
        <h2>8th June 2025 – Community Outreach at St. Maria Assumpta</h2>
        <p>
          The Mwangaza Wellness and Medical Centre team participated in a community outreach at St. Maria Assumpta Catholic Church – Kiamwangi. During the visit, Prof. Irimu introduced the Centre and addressed the rising burden of diabetes and hypertension among younger Kenyans. She emphasized the importance of preventive care, early screening, and lifestyle awareness to reduce severe complications such as kidney failure and amputations.
        </p>
        <p className="achievement"><strong>Achievement:</strong> Engaged the parish in meaningful dialogue about prevention, and strengthened community ties through faith-based health education.

</p>
        <div className="media-gallery row-layout">
          <img src={img6a} alt="Kiamwangi Outreach 1" />
          <img src={img6b} alt="Kiamwangi Outreach 2" />
          <img src={img6c} alt="Kiamwangi Outreach 3" />
        </div>
      </section>

      <div className="red-divider"></div>

    {/* Section 7 */}
      <section className="media-section">
        <h2>21st June – JPRC Kiawara Parish (Mweiga)</h2>
        <p>
          On 21st June 2025, Mwangaza Wellness and Medical Centre conducted a half-day session with over 70 JPRC (Justice, Peace, Reconciliation and Creation) members from Kiawara at PCEA Kiawara Church. The session focused on understanding hypertension and diabetes, and emphasized lifestyle interventions such as healthy eating, weight management, and physical activity.
        </p>
        <p className="achievement"><strong>Achievement:</strong> Officially launched the Mwangaza Diabetes Campaign at PCEA Kiawara on 21st June 2025—a strategic initiative aimed at raising awareness, screening, and education on diabetes. The campaign runs until 14th November 2025, culminating on World Diabetes Day.</p>
        <div className="media-gallery row-layout">
          <img src={img7a} alt="Kiawara JPLC 1" />
          <img src={img7b} alt="Kiawara JPLC 2" />
          <img src={img7c} alt="Kiawara JPLC 3" />
        </div>
      </section>

      <div className="red-divider"></div>


    </div>
  );
};

export default MediaPage;
